<template>
  <div class="club-page">
    <header class="page-head">
      <div class="container">
        <h1 class="page-head__title">Clube</h1>
        <p class="page-head__lead">
          Espaço de lazer do sindicato dos bancários de Uberlândia.
        </p>
      </div>
    </header>

    <div class="container club-page__body">
      <div class="club-page__media">
        <v-carousel cycle height="auto" hide-delimiters show-arrows-on-hover class="club-carousel">
          <v-carousel-item v-for="(item, index) in items" :key="index">
            <img :src="item.img" :alt="`Foto ${index + 1} do Clube`" class="club-carousel__image" />
          </v-carousel-item>
        </v-carousel>
      </div>

      <div class="club-page__info">
        <ul class="club-places">
          <li v-for="(place, i) in address" :key="i" class="club-places__item">
            <v-icon class="club-places__icon" aria-hidden="true">{{ place.icon }}</v-icon>
            <div v-html="place.text" />
          </li>
        </ul>

        <iframe
          class="club-page__map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d943.7038059368748!2d-48.28146292490158!3d-18.89527670456098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94a4443303d140f5%3A0x5f8a4232a5b7bb50!2sR.%20Domingos%20Ant%C3%B4nio%20Cal%C3%A1bria%2C%20240%20-%20Pres.%20Roosevelt%2C%20Uberl%C3%A2ndia%20-%20MG%2C%2038401-222!5e0!3m2!1spt-BR!2sbr!4v1596899941177!5m2!1spt-BR!2sbr"
          title="Localização do Clube no mapa"
          loading="lazy"
          frameborder="0"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'club',
  metaInfo: {
    title: "SEEB | Clube",
    meta: [
      { name: 'description', content: 'Clube do sindicato dos bancarios de Uberlândia.' }
    ]
  },
  data: () => ({
    address: [
      {
        icon: "mdi-map-marker-outline",
        text: "<b>ENDEREÇO CLUBE</b><br>R. Domingos Antônio Calábria, 240. - Roosevelt<br>Uberlândia - MG, 3215-1729"
      },
      {
        icon: "mdi-map-marker-outline",
        text: "<b>ENDEREÇO CASA DE MADEIRA</b><br>R. Professor Leônidas de Castro Serra, 131. - Roosevelt<br>Uberlândia - MG, 38401-224"
      },
      {
        icon: "mdi-cellphone",
        text: "<b>TELEFONE</b><br>(34) 3236 7277<br>(34) 3236-3803 - Fax"
      }
    ],
    items: [
      { img: require('../../../../assets/clube0.jpeg') },
      { img: require('../../../../assets/clube1.jpeg') },
      { img: require('../../../../assets/clube2.jpeg') },
      { img: require('../../../../assets/clube3.jpeg') },
      { img: require('../../../../assets/clube4.jpeg') },
      { img: require('../../../../assets/clube6.jpeg') },
      { img: require('../../../../assets/clube7.jpeg') },
      { img: require('../../../../assets/clube8.jpeg') }
    ]
  })
};
</script>

<style lang="scss" scoped>
.club-page {
  padding-bottom: var(--section);

  &__body {
    display: grid;
    grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr);
    gap: clamp(32px, 4vw, 56px);
    align-items: start;
    padding-top: clamp(40px, 5vw, 64px);
  }

  &__media {
    border-radius: var(--radius);
    overflow: hidden;
    background: #e6e9ee;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  &__map {
    width: 100%;
    height: 280px;
    border: 0;
    border-radius: var(--radius);
  }

  @media (max-width: 899px) {
    &__body {
      grid-template-columns: 1fr;
    }
  }
}

.club-carousel__image {
  display: block;
  width: 100%;
  aspect-ratio: calc(4 / 3);
  object-fit: cover;
}

.club-places {
  list-style: none;
  margin: 0;
  padding: 0;

  &__item {
    display: flex;
    gap: 16px;
    padding: 20px 0;
    border-bottom: 1px solid var(--c-line);
    font-size: var(--fs-body);
    line-height: 1.6;
    color: var(--c-ink);

    &:first-child {
      padding-top: 0;
    }
  }

  &__icon {
    flex-shrink: 0;
    margin-top: 2px;
    color: var(--c-navy-deep) !important;
  }
}
</style>
